import customColors from './custom-colors';

export default {
  customColors,
};
